const missingContentType = ''; // Windows 10 does not supply a file content type for excel nor csv, so we will not enforce client side validations.
const acceptedExcel = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', missingContentType];
const acceptedCsv = ['text/csv', 'text/comma-separated-values'];

const fileTypeDetails = (fileType) => {
  switch (fileType) {
  case "spreadsheet":
    return {
      message: "Click to browse, or drag a .xlsx, .xls or .csv file into this box.",
      mimeTypes: acceptedExcel.concat(acceptedCsv).join(", ")
    };
  case "excel":
    return {
      message: "Click to browse, or drag a .xlsx or .xls file into this box.",
      mimeTypes: acceptedExcel.join(", ")
    };
  case "image":
    return {
      message: "Click to browse, or drag a .jpg, .jpeg, .gif, or .png file into this box.",
      mimeTypes: "image/jpg, image/jpeg, image/png, image/gif"
    };
  case "any":
    return {
      message: "Click to browse, or drag a file into this box.",
      mimeTypes: ""
    };
  default:
    return {
      message: "Click to browse, or drag a file into this box.",
      mimeTypes: fileType
    };
  }
};

export default fileTypeDetails;
